import style from 'styled-components';
import { Row, Select } from 'antd';
import { theme } from '../../../config/theme/themeVariables';

const ScheduleContainer = style.div`

    margin-bottom: 100px;
    .add-service {
    }
    .rbc-event:hover {
        z-index: 2;
    }
    .rbc-selected {
        z-index: 2;
    }
    .ant-tabs-nav{
        margin: 0;
    }
`;

const InputTime = style.div`

input[type="date"]::-webkit-calendar-picker-indicator{
    display: block;
    background: transparent;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
}
input[type="time"]::-webkit-calendar-picker-indicator{
    display: block;
    background: transparent;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
}

`;

const Button = style.button`
.buttonFilter{

    width:300px;
}
`;

const PageContent = style.section`

`;

const CalendarActions = style.div`
    button {
        margin: 5px;
    }
`;

const SelectView = style.div`
    .ant-select {
        
    }
    .ant-select-open {
        .ant-select-arrow {
            color: #fff;
        }
        .ant-select-selector {
            .ant-select-selection-item {
                color: #fff;
            }
            background: ${theme['secondary-color']};
            color: #ffffff;
        }
    }
    
    .ant-select-selector {
        border-color: ${theme['secondary-color']};
        color: ${theme['secondary-color']};
    }
    .ant-select-arrow {
        color: ${theme['secondary-color']};
    }
    .ant-select-dropdown {
        .ant-select-item .ant-select-item-option-content {
            font-weight: 600;
            color: ${theme['secondary-color']};
        }
        .ant-select-item.ant-select-item-option-selected {
            background: ${theme['secondary-color']} !important;
            .ant-select-item-option-content {
                color: #fff;
            }
        }
        .ant-select-item.ant-select-item-option-active:not(.ant-select-item-option-selected) {
            background: ${theme['secondary-color']}20 !important;
        }
    }
`;

const SelectViewOption = style(Select.Option)`
  color: red;
`;

const ContentSwitches = style(Row)`
  margin-bottom:30px
`;

const ContentActions = style.ul``;

const ActionItem = style.div`
  display: flex;
  gap: 20px;
  justify-content: left;
  :hover {
    /* font-weight: 570; */
    background-color: #e4e7ea;
  }
  .anticon {
    margin-top: 4px;
  }
  .buttonAction {
    display: flex;
    border: none;
    width: 100%;
    background: transparent;
    justify-content: left;
  }
`;
const CounterContainerService = style.div`
  background: #DCEAF7;
  text-align: center;
  width: 100%;
  padding: 0.8%;
  border-radius: 7px;
`


const ContentIncidentForm = style(Row)`
  margin-bottom: 23px !important;
  margin-left: 10px;
`;


export {
  ScheduleContainer,
  PageContent,
  CalendarActions,
  SelectView,
  SelectViewOption,
  Button,
  InputTime,
  ContentSwitches,
  ContentActions,
  ActionItem,
  CounterContainerService,
  ContentIncidentForm
};
